import React, { Component } from "react";
import Header from "./../../Common/Layout/Header";
import SubHeader from "./../../Common/Layout/SubHeader";
import Footer from "./../../Common/Layout/Footer";
import CategoriesTable from "./CategoriesTable";

class Categories extends Component {
    constructor() {
        super()

        this.state = {
            subHeaderItems: [],
            helpMenuItems: [
                //{
                //    name: "Help",
                //    url: "Help URL",
                //    position: "bottom left"
                //},
                //{
                //    name: "Video",
                //    url: "Video URL",
                //    position: "bottom center"
                //},
                //{
                //    name: "User Guide",
                //    url: "",
                //    position: "bottom right"
                //},
            ]
        }
    }

    componentDidMount() {

    }
    /* 
                  <Header />
                  <Footer />
    */
    render() {
        return (
            <div >
                <SubHeader subHeaderMenuItems={this.state.subHeaderItems} helpMenuItems={this.state.helpMenuItems} showClose={false} />
                <CategoriesTable />
            </div>
        );
    }
}


export default Categories;
